export interface ResumeProtocol {
  _id?: string;
  personalDetails: {
    name: string;
    email: string;
    phone?: string;
    location?: {
      city: string;
      state?: string;
      country: string;
      postalCode?: string;
    };
    portfolioWebsite?: string;
    linkedinProfile?: string;
    githubProfile?: string;
  };
  professionalSummary?: string;
  workExperience: {
    companyName: string;
    jobTitle: string;
    startDate: string;
    endDate?: string | null;
    isCurrentJob?: boolean;
    location?: {
      city: string;
      state?: string;
      country: string;
    };
    responsibilities?: string[];
    achievements?: string[];
  }[];
  education: {
    institutionName: string;
    degree: string;
    fieldOfStudy?: string;
    startDate: string;
    endDate?: string | null;
    isCurrentEducation?: boolean;
    location?: {
      city: string;
      state?: string;
      country: string;
    };
  }[];
  skills?: {
    skillName: string;
    proficiencyLevel?: 'Beginner' | 'Intermediate' | 'Advanced' | 'Expert';
  }[];
  certifications?: {
    certificationName: string;
    issuingOrganization: string;
    issueDate: string;
    expiryDate?: string | null;
    credentialURL?: string;
  }[];
  projects?: {
    projectName: string;
    description: string;
    startDate: string;
    endDate?: string | null;
    technologiesUsed?: string[];
    projectURL?: string;
  }[];
  languages?: {
    languageName: string;
    proficiencyLevel?: 'Basic' | 'Conversational' | 'Fluent' | 'Native';
  }[];
  references?: {
    referenceName: string;
    relationship: string;
    contactInfo: string;
  }[];
  additionalInformation?: string;
  updatedAt?: string;
}

export interface UserPreferences {
  jobRoles: string[];
  experienceLevel: string;
  languages: string[];
  interviewGoals: string[];
} 


export function getResumeInInterviewFormat(resume: ResumeProtocol | null): string {
  console.log('[getResumeInInterviewFormat] Preparing resume in interview format for resume:', resume);
  if (!resume) {
    return '';
  }
  return `
  Name: ${resume.personalDetails.name},
  Professional Summary: ${resume.professionalSummary},
  Work Experience: ${resume.workExperience.map(experience => `
    Company: ${experience.companyName}
    Job Title: ${experience.jobTitle}
    Responsibilities: ${experience.responsibilities?.join(', ')}
    Achievements: ${experience.achievements?.join(', ')}
  `).join('\n')},
  Education: ${resume.education.map(education => `
    Institution: ${education.institutionName}
    Degree: ${education.degree}
    Field of Study: ${education.fieldOfStudy}
  `).join('\n')},
  Skills: ${resume.skills?.map(skill => `
    Skill: ${skill.skillName}
    Proficiency Level: ${skill.proficiencyLevel}
  `).join('\n')},
  Certifications: ${resume.certifications?.map(certification => `
    Certification: ${certification.certificationName}
    Issuing Organization: ${certification.issuingOrganization}
  `).join('\n')},
  Projects: ${resume.projects?.map(project => `
    Name: ${project.projectName}
    Description: ${project.description}
    Skills Used: ${project.technologiesUsed?.join(', ')}
  `).join('\n')},
  
  `;
}